import { Badge } from '@/components/ui/badge'
import { TableCell, TableRow } from '@/components/ui/table'
import type { AgentModelRow } from '@/models/agentRunReport'
import { METRIC_COLUMNS } from './agentColumns'

/** One agent's models side by side — the vendor comparison these rows exist for. */
export function AgentModelRows({ models }: { models: AgentModelRow[] }) {
  return (
    <>
      {models.map((model) => (
        <TableRow key={`${model.vendor}-${model.model}`} className="bg-ink-50/60">
          <TableCell className="pl-8">
            <span className="flex items-center gap-2">
              <span className="font-mono text-xs">{model.model || '—'}</span>
              <Badge variant="outline">{model.vendor}</Badge>
            </span>
          </TableCell>
          {METRIC_COLUMNS.map((column) => (
            <TableCell key={column.key} className="text-ink-600 text-right text-sm tabular-nums">
              {column.render(model)}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  )
}
